import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import './Auth.css';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  
  const { register } = useAuth();
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!agreeToTerms) {
      return toast.error('Trebuie să acceptați Termenii și Condițiile');
    }

    if (password !== confirmPassword) {
      return toast.error('Parolele nu coincid');
    }
    
    try {
      setLoading(true);
      await register(email, password);
      toast.success('Cont creat cu succes!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Register error:', error);
      toast.error(error.message || 'Înregistrare eșuată');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Creare Cont</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Introdu email-ul tău"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Parolă</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Creează o parolă"
              minLength="6"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmă Parola</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Confirmă parola"
              minLength="6"
            />
          </div>
          
          <div className="form-group checkbox-group">
            <input
              type="checkbox"
              id="terms"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
              required
            />
            <label htmlFor="terms">
              Am citit și sunt de acord cu <Link to="/terms" target="_blank">Termenii și Condițiile</Link>
            </label>
          </div>
          
          <button
            type="submit"
            className="btn primary-btn"
            disabled={loading}
          >
            {loading ? 'Se creează contul...' : 'Înregistrare'}
          </button>
        </form>
        
        <div className="auth-redirect">
          <p>Ai deja un cont?</p>
          <Link to="/login">Autentifică-te aici</Link>
        </div>
      </div>
    </div>
  );
};

export default Register;